import { AxiosResponse } from 'axios';

import Resolver from 'src/common/Resolver';
import usePublicPagesStore from 'src/stores/publicPagesStore';
import Pages from './Pages';

const PagesResolver = () => {
  const { fetchPublicPages } = usePublicPagesStore(s => s);

  const loadDependencies = () =>
    Promise.all([
      fetchPublicPages().catch(() => undefined),
    ] as Array<Promise<void | AxiosResponse<unknown>>>);

  return <Resolver resolve={loadDependencies} successComponent={Pages} />;
};

export default PagesResolver;
